
const BgLinearTop = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 393 258"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_2004)">
        <rect width="393" height="258" fill="white" />
        <g filter="url(#filter0_f_1_2004)">
          <ellipse cx="196.5" cy="-54" rx="164.5" ry="142" fill="url(#paint0_linear_1_2004)" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_1_2004"
          x="-143"
          y="-371"
          width="679"
          height="634"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="87.5" result="effect1_foregroundBlur_1_2004" />
        </filter>
        <linearGradient
          id="paint0_linear_1_2004"
          x1="32"
          y1="-52.8992"
          x2="361"
          y2="-52.9594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0091AA" />
          <stop offset="1" stopColor="#57C785" />
        </linearGradient>
        <clipPath id="clip0_1_2004">
          <rect width="393" height="258" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export { BgLinearTop }
